const data = {
  columns: [
    {
      label: "Action",
      field: "action",
      width: 12,
    },
    {
      label: "Status",
      field: "status",
      width: 100,
    },
    {
      label: "Client",
      field: "consumer_name",
    },
    {
      label: "Agent",
      field: "user_name",
    },
    {
      label: "Skill",
      field: "skill_name",
    },
    {
      label: "Group",
      field: "group"
    },
    {
      label: "Queue Time",
      field: "queue_time",
    },
    {
      label: "Start",
      field: "created_at",
      extrafield: "initial_conversation_time"
    },
    {
      label: "End",
      field: "end_conversation_time",
    },
    {
      label: "TA",
      field: "ta",
    },
    {
      label: "Duration",
      field: "duration",
    },
    {
      label: "Last Message",
      field: "last_message_time",
    },
    {
      label: "Last Message Client",
      field: "last_msg_consumer",
    },
    {
      label: "CSAT",
      field: "csat",
    },
    {
      label: "NPS",
      field: "nps",
    },
  ],
};

export default data;
